import type { RouteRecordRaw } from 'vue-router'

import { registerAnomalyMessages } from './i18n'

import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

export const ANOMALIES_ROUTE = { name: 'Anomalies' } as const

export const anomalyRoutes: RouteRecordRaw[] = [
  {
    path: 'anomalies',
    name: ANOMALIES_ROUTE.name,
    component: () => import('./components/AnomaliesPage.vue'),
    meta: {
      navKey: 'anomalies',
      titleKey: 'anomalies.page.title',
      // Live v3 adds 1.5rem inside the shell's default 0.5rem canvas gutter.
      contentInset: 'spacious',
    },
    beforeEnter: async () => registerAnomalyMessages(activeLocale()),
  },
]
